const header = document.querySelector('.j-header');

const breakpoint = window.matchMedia('(min-width:1280px)');
const defaultOffset = 0;

let lastScroll = 0;
let scrollPosition = 0;
let containHide = false;

const hideHeader = () => {
    requestAnimationFrame(() => {
        header.classList.add('header_status_scrolling', 'header_status_hide');

        setTimeout(() => {
            header.classList.add('header_theme_blue');
        }, 200);
    });
};

const showHeader = () => {
    requestAnimationFrame(() => {
        header.classList.remove('header_status_hide');
    });
};

const removeEffects = () => {
    requestAnimationFrame(() => {
        if (header.classList.contains('header_status_scrolling')) {
            header.classList.remove('header_status_scrolling', 'header_theme_blue');
            header.classList.add('header_status_animated');

            setTimeout(() => {
                header.classList.remove('header_status_animated');
            }, 400);
        }
    });
};

const scrollPage = () => {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    containHide = header.classList.contains('header_status_hide');

    if (scrollPosition > lastScroll && !containHide && scrollPosition > defaultOffset) {
        hideHeader();
    } else if (scrollPosition < lastScroll && containHide) {
        showHeader();
    }

    if (scrollPosition === defaultOffset && window.location.pathname.length === 1) {
        removeEffects();
    }

    lastScroll = scrollPosition;
};

const changeBreakpoint = (evt) => {
    const matches = evt ? evt.matches : breakpoint.matches;

    if (matches) {
        showHeader();
        removeEffects();

        window.removeEventListener('scroll', scrollPage);
    } else {
        scrollPage();

        window.addEventListener('scroll', scrollPage);
    }
};

const initHeaderMobile = () => {
    if (!header) {
        return;
    }

    breakpoint.addListener(changeBreakpoint);

    changeBreakpoint();
};

export {initHeaderMobile};
